import { FaviconDefaultIcon } from '@/assets/icons/custom/favicon-default.icon';
import { useState } from 'react';
import { CameraIcon } from '@/assets/icons/camera.icon';
import useFavicoUpload from '@/modules/playground/hooks/useFavicoUpload.hook';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import { CloseIcon } from '@/assets/icons/close.icon';

const Favico = () => {
  const { fileInputRef, openExplorer, uploadFavicoHandler, removeFavicoHandler } = useFavicoUpload();
  const { state } = usePlayground();

  const [hasImageError, setHasImageError] = useState<boolean>(false);

  const onImageError = () => {
    setHasImageError(true);
  };

  const renderThumbnail = () => {
    if (hasImageError) {
      return <FaviconDefaultIcon />;
    }

    if (state.payload.site_settings?.favico_url) {
      return (
        <img
          src={state.payload.site_settings?.favico_url}
          alt="User Linkie Favicon"
          className="w-full h-full object-contain mt-2"
          onError={onImageError}
        />
      );
    }

    return <img src="/brand/logos/beta/favicon.ico" alt="Linkie Favicon" className="mt-2" />;
  };

  return (
    <>
      <div className="relative group/thumbnail cursor-pointer w-[52px] h-[52px]" onClick={openExplorer}>
        {renderThumbnail()}
        <div className="absolute inset-0 bg-black opacity-0 group-hover/thumbnail:opacity-40 rounded-lg transition-all duration-200"></div>
        <div className="absolute z-10 inset-0 flex items-center justify-center text-white opacity-0 group-hover/thumbnail:opacity-100 transition-all duration-200">
          <CameraIcon size={4} />
        </div>

        {state.payload.site_settings?.favico_url ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
              removeFavicoHandler();
            }}
          >
            <CloseIcon className="size-4 absolute -top-2 -right-2 cursor-pointer z-50 bg-failed rounded-full" />
          </div>
        ) : null}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept=".jpg,.jpeg,.png,.webp"
        className="hidden"
        id="favico"
        name="favico"
        onChange={(e) => uploadFavicoHandler(e)}
      />
    </>
  );
};

export default Favico;
